import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { DocumentService } from "../../services/document/document.service";
import {MessageService} from "primeng/api";
import {DocumentResponse} from "../../models/document/documentResponse";
import * as FileSaver from 'file-saver'

@Component({
  selector: 'app-document-btn',
  templateUrl: './document-btn.component.html',
  styleUrls: ['./document-btn.component.scss']
})
export class DocumentBtnComponent implements OnInit {

  @Input() entityId: number;
  @Input() showModal: boolean = false;

  @ViewChild('fileUpload') fileUpload: any;

  isLoading: boolean = false;
  documents: DocumentResponse[] = [];
  loading: boolean = true;

  constructor(private documentService: DocumentService, private messageService: MessageService) { }

  onUpload(event) {
    if(!event || !event.files || event.files.length == 0 || !this.entityId) return;
    const file: File = event.files[0];
    this.fileUpload.clear();
    this.documentService.upload(file, this.entityId).subscribe(() => {
      this.messageService.add({severity: 'success', summary: '', detail: 'Kayıt başarılı.' });
      this.getDocuments();
    })
  }


  getDocuments() {
    this.documentService.getDocuments(this.entityId).subscribe(r =>{
        this.documents = r;
        this.loading = false;
    } );
  }
  ngOnInit(): void {

  }
  async getDoc(doc: any) {
    try {
      this.isLoading = true;
      const resp = await this.documentService.getDoc(doc.id).toPromise();
      this.isLoading = false;
      if(!resp) return;
      FileSaver.saveAs(resp, doc.obj.fileName, { type: 'application/octet-stream'});
    } catch (e)  {
      this.isLoading = false;
    }

  }

}
